/**
 * Inline promoted-article embeds: same visual language as ViralNewsSidebar (viral news preview row).
 * Markup: data-cms-embed="promoted-article" + .cms-promoted-inner (see rich-text-editor).
 */
export const CMS_PROMOTED_ARTICLE_STYLES = `
      /* Card shell — matches sidebar Card (shadow, radius) */
      .article-content-html [data-cms-embed="promoted-article"],
      .article-content-html a.cms-promoted-article {
        display: block !important;
        max-width: 100% !important;
        width: 100% !important;
        margin: 1rem 0 !important;
        clear: both !important;
        float: none !important;
        text-align: left !important;
        position: relative !important;
        text-decoration: none !important;
        color: inherit !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
        background: #ffffff !important;
        border-radius: 5px !important;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.12) !important;
        overflow: hidden !important;
      }
      /* "Promotion" strip — matches ViralNewsSidebar SidebarSection header */
      .article-content-html [data-cms-embed="promoted-article"]::before,
      .article-content-html a.cms-promoted-article::before {
        content: "Promotion" !important;
        display: block !important;
        position: relative !important;
        background-color: #4a4a4a !important;
        color: #ffffff !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 1.3 !important;
        padding: 8px 12px 8px 16px !important;
        margin: 0 !important;
        border-left: 4px solid #D00501 !important;
        box-sizing: border-box !important;
        border-radius: 0 !important;
      }
      .article-content-html [data-cms-embed="promoted-article"]:hover .cms-promoted-inner,
      .article-content-html a.cms-promoted-article:hover .cms-promoted-inner {
        background-color: #fafafa !important;
      }
      /* Row — matches sidebar Link > div.flex.gap-2 */
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-inner,
      .article-content-html a.cms-promoted-article .cms-promoted-inner {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        gap: 0.5rem !important;
        padding: 12px !important;
        margin: 0 !important;
        border: none !important;
        border-radius: 0 !important;
        background-color: #ffffff !important;
        box-sizing: border-box !important;
        max-width: 100% !important;
      }
      /* Thumbnail w-20 h-20 */
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-thumb,
      .article-content-html a.cms-promoted-article .cms-promoted-thumb {
        position: relative !important;
        width: 5rem !important;
        height: 5rem !important;
        min-width: 5rem !important;
        min-height: 5rem !important;
        flex-shrink: 0 !important;
        overflow: hidden !important;
        border-radius: 0.25rem !important;
        background-color: #f4f4f5 !important;
        margin: 0 !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-thumb img,
      .article-content-html a.cms-promoted-article .cms-promoted-thumb img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        display: block !important;
        margin: 0 !important;
        max-width: none !important;
        transition: transform 0.3s ease !important;
      }
      .article-content-html [data-cms-embed="promoted-article"]:hover .cms-promoted-thumb img,
      .article-content-html a.cms-promoted-article:hover .cms-promoted-thumb img {
        transform: scale(1.05) !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-body,
      .article-content-html a.cms-promoted-article .cms-promoted-body {
        flex: 1 !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-title,
      .article-content-html a.cms-promoted-article .cms-promoted-title,
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-body h4,
      .article-content-html a.cms-promoted-article .cms-promoted-body h4 {
        position: relative !important;
        font-size: 14px !important;
        line-height: 20px !important;
        font-weight: 600 !important;
        margin: 0 0 4px 0 !important;
        padding: 0 !important;
        color: #0f172a !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        display: -webkit-box !important;
        -webkit-line-clamp: 2 !important;
        -webkit-box-orient: vertical !important;
      }
      .article-content-html [data-cms-embed="promoted-article"]:hover .cms-promoted-title,
      .article-content-html a.cms-promoted-article:hover .cms-promoted-title,
      .article-content-html [data-cms-embed="promoted-article"]:hover .cms-promoted-body h4,
      .article-content-html a.cms-promoted-article:hover .cms-promoted-body h4 {
        color: #2563eb !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-excerpt,
      .article-content-html a.cms-promoted-article .cms-promoted-excerpt {
        font-size: 12px !important;
        font-weight: 400 !important;
        line-height: 1.4 !important;
        margin: 0 0 6px 0 !important;
        padding: 0 !important;
        color: #71717a !important;
        display: -webkit-box !important;
        -webkit-line-clamp: 2 !important;
        -webkit-box-orient: vertical !important;
        overflow: hidden !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-meta,
      .article-content-html a.cms-promoted-article .cms-promoted-meta {
        display: flex !important;
        flex-wrap: wrap !important;
        align-items: center !important;
        gap: 0.5rem !important;
        font-size: 12px !important;
        line-height: 1.25 !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #71717a !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-meta span,
      .article-content-html a.cms-promoted-article .cms-promoted-meta span {
        display: inline !important;
        margin: 0 !important;
      }
      .article-content-html [data-cms-embed="promoted-article"] .cms-promoted-inner > div,
      .article-content-html a.cms-promoted-article .cms-promoted-inner > div {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
      .article-content-html .promoted-article-wrapper {
        display: block !important;
        max-width: 100% !important;
        width: 100% !important;
        margin: 1rem 0 !important;
        background: #ffffff !important;
        border-radius: 5px !important;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.12) !important;
        overflow: hidden !important;
      }
      .article-content-html .promoted-article-wrapper::before {
        content: "Promotion" !important;
        display: block !important;
        background-color: #4a4a4a !important;
        color: #ffffff !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        padding: 8px 12px 8px 16px !important;
        border-left: 4px solid #D00501 !important;
        box-sizing: border-box !important;
      }
      /* Legacy: anchor > single flex div (no .cms-promoted-inner) */
      .article-content-html a.cms-promoted-article > div:not(.cms-promoted-inner) {
        display: flex !important;
        align-items: flex-start !important;
        gap: 0.5rem !important;
        padding: 12px !important;
        margin: 0 !important;
        border: none !important;
        border-radius: 0 !important;
        background-color: #ffffff !important;
        box-sizing: border-box !important;
        max-width: 100% !important;
      }
      .article-content-html a.cms-promoted-article > div:not(.cms-promoted-inner) p {
        font-size: 12px !important;
        line-height: 1.4 !important;
        font-weight: 400 !important;
        margin: 0.25rem 0 0 0 !important;
        color: #71717a !important;
      }
`

export function ensureCmsPromotedArticleStyles(): void {
  if (typeof document === "undefined") return
  const id = "cms-promoted-article-styles"
  if (document.getElementById(id)) return
  const style = document.createElement("style")
  style.id = id
  style.textContent = CMS_PROMOTED_ARTICLE_STYLES
  document.head.appendChild(style)
}
